<template>
   <div>
      <div style="color:red;text-indent:2em;">  友情提示：在分销系统中出单，如果是选择预存模式出单，只需要上传被保障人信息，提交成功后则直接扣除预存款；如果二维码保存不当，会出现盗刷等情况，如若出现不明账单，平台可提供订单记录，但费用扣除不可更改，由商家自行承担费用，请明悉！</div>
      <div class="Recharge">
          <div class="left" style="font-size:20px">
             预存账户
             
             <div>
               <div class="je">
                    <div><b style="font-size: 25px;">{{ totalRechargeAmount/100 }}元</b></div>
                    <div><b style="font-size: 23px;">累计充值金额</b></div>
               </div>
                 <div class="je">
                    <div><b style="font-size: 25px;">{{ totalPayAmount/100 }}元</b></div>
                    <div><b style="font-size: 23px;">累计消费金额</b></div>
               </div>
                 <div class="je">
                    <div><b style="font-size: 25px;">{{ balance/100 }}元</b></div>
                    <div><b style="font-size: 23px;">目前账户金额</b></div>
               </div>
               <div style="text-align: center;width: 36%;float: right;">
                   <el-button type="primary" style="height: 30px;line-height: 3px;margin-top: 10px;" @click="tx" v-if="status == 1">提现</el-button>
                   <el-button type="primary" style="height: 30px;line-height: 3px;margin-top: 10px;" disabled v-if="status == 2">审核中</el-button>
               </div>
                 
             </div>
          </div>
          <div class="left" style="font-size:20px">
             <!-- 充值额度选择 -->
             <!-- <span  style="float: right;cursor: pointer;margin-left: 15px;" :class="{ act1: actfsshow == 1}" @click="Rechargemode(2)" >(对公充值)</span>
             <span  style="float: right;cursor: pointer;" :class="{ act1: actfsshow == 2}" @click="Rechargemode(1)">(微信充值)</span> -->
            
              <span style="font-size: 16px;color: #409eff;display: inline-block;text-align: right;width: 100%;">
                <span  style="float: right;cursor: pointer;color: #409eff;font-size: 16px;margin-left:20px" @click="balanceSettings">余额不足提醒设置</span> 
                当前账户类型<span v-if="rechargeType == 1">微信</span><span v-else>对公</span>
              </span>
             <div style="margin-top:33px">
                 <div class="jeclass" :class="{ act: actshow == 1}" @click="act(1)"><b>1000元</b></div>
                 <div class="jeclass" :class="{ act: actshow == 2}" @click="act(2)"><b>5000元</b></div>
                 <div class="jeclass" :class="{ act: actshow == 3}" @click="act(3)"><b>10000元</b></div>
                 <div class="jeclass" style=" margin-right: 0px" :class="{ act: actshow == 4}" @click="act(4)"><b>自定义</b></div>
             </div>
           
             <div style="text-align: center;margin-top: 20px;">
              <div>
                <el-input style="width: 46%;float: left;" v-if="actshow == 4" v-model="amount" placeholder="请输入金额"></el-input>
                <el-button style="width:200px" type="primary" :disabled="status == 2" @click="cz">充值</el-button>
              </div>
            </div>
          </div>
      </div>
      <div style="font-size: 20px;padding: 20px 0px 10px 0px;">充值/提现记录</div>
          <el-table
          
            :data="tableData"
            border
            style="width: 100%;">
            <!-- <el-table-column
              prop="accountId"
              label="id"
              width="150px">
            </el-table-column> -->
            <el-table-column
              prop="billingNo"
              label="订单号"
              width="300px">
            </el-table-column>
            <el-table-column
              prop="tradeNo"
              label="流水号"
              width="300px">
            </el-table-column>
            <el-table-column
              prop="recordType"
              label="类别"
              width="150px">
            </el-table-column>
            <el-table-column
              label="金额"
              width="150px">
              <template slot-scope="scope">
                  {{scope.row.amount / 100}}元
              </template>
            </el-table-column>
            <el-table-column
              label="时间"
              width="250px">
              <template slot-scope="scope">
                  {{setTime(scope.row.createAt)}}
              </template>
            </el-table-column>
             <el-table-column
              label="状态"
              width="200px">
              <template slot-scope="scope">
                  {{setstatus(scope.row.status)}}
              </template>
            </el-table-column>
            <!-- <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                <el-button type="text" size="small">编辑</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
          style="float: right;margin-top: 15px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      <el-dialog
        title="退款信息确认"
        :visible.sync="dialogVisible"
        width="20%"
       >
         <div style="text-align: left;margin-top: -35px;color: red;">目前默认信息余额全部退款</div>
          <div style="margin-top: 15px;" v-if="rechargeType != 1">姓名：{{name}}</div>
          <div style="margin-top: 15px;">退款金额：{{balance/100}}元</div>
          <div style="margin-top: 15px;">账户余额：{{balance/100}}元</div>
          <div style="margin-top: 15px;">退款账户：按支付账户原路返回<span v-if=" rechargeType == 1">（微信）</span><span v-else>（对公）</span></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="tk();dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
        <el-dialog
        title="充值信息确认"
        :visible.sync="dialogVisible1"
        width="20%"
       >
       <div v-if="rechargeType == 1">
            <div style="margin-top: 15px;">充值金额：{{amount}}元</div>
              <div style="margin-top: 15px;">目前账户余额：{{balance/100}}元</div>
              <el-radio v-model="radio" label="1" style="margin-top:15px">微信</el-radio>
              <div slot="footer" class="dialog-footer" style="margin-top:15px">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="fu();dialogVisible1 = false">确 定</el-button>
              </div>
       </div>
          <div v-else>
            <div style="margin-top: 15px;">充值金额：{{amount}}元</div>
              <div style="margin-top: 15px;">目前账户余额：{{balance/100}}元</div>
              <span>充值方式：</span>
              <el-radio v-model="radio" label="1" style="margin-top:15px">对公转账</el-radio>
               <div style="margin-top: 30px;"><b>转账账户信息</b></div>
               <div style="margin-top: 15px;">账户名称：江泰救援服务有限公司</div>
                <div style="margin-top: 15px;">开户行：招商银行北京丽泽商务区支行</div>
                 <div style="margin-top: 15px;">银行账号：1109 2162 2710 301</div>

                 <div style="margin-top:30px">
                    <div style="color:orange">如果您已充值汇款，请填写账户信息，财务人员审核后充值成功。</div>
                    <div style="margin-top:15px">
                    <div style="display: inline-block;">
                        <span style="color:red">*</span>汇款账户名：
                    </div>
                    <div style="display: inline-block;width: 70%;">
                      <el-input v-model="bankAccount" placeholder="请输入汇款账户名"></el-input>
                    </div>
                    
                    </div>
                 </div>
              <div slot="footer" class="dialog-footer" style="margin-top:15px">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="fu1();dialogVisible1 = false">确 定</el-button>
              </div>
       </div>
      </el-dialog>
      <el-dialog
          title="分销充值"
          :visible.sync="dialogVisible2"
          width="20%"
         >
          <span>
            <div style="text-align: center;">订单价格：{{amount}}</div>
            <vue-qr class='fukuan fukuan1' :logoSrc="config.imagePath" :text="payImg" :size="400"></vue-qr>
          </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible2 = false;prestoretopay()">确 定</el-button>
        </span>
      </el-dialog>
       <el-dialog
        title="友情提示"
        :close-on-click-modal="false" 
        :show-close="false"
        :visible.sync="dialogVisible0"
        width="20%"
       >
       用户在清单保障期间内，因遭受约定的意外伤害事故或突发急性病时，大救星可安排紧急医疗转运、医疗送返、电话医学咨询等服务，费用由大救星承担：
医疗运送：经本机构授权的医生从医疗角度认为权益人病情需要，且事故发生地医院条件不能保证权益人得到充分的救治时，救援服务机构将以事发地能够提供的最合适的方式安排医疗设备、运输工具及随行医护人员，将权益人转运至授权医生认为更适当的医院接受治疗，本机构承担相应的运送费用。
医疗送返：经本机构授权的医生从医疗角度认为有必要将权益人运送回其在境内的常住地，或经授权医生和权益人的主治医生共同认定权益人的病情或伤势已稳定且可以运送回其在境内的常住地时，本机构将安排权益人搭乘普通航班（经济舱）、轮船、火车、汽车或以其他更经济的交通方式运送回其境内常住地或距离其常住地最近的医院，本机构承担相应的运送费用。在此情况下，本机构将尽量使用权益人原先购买的返程票；返程票失效的，本机构将收回处理。
住院期间医疗费用担保或垫付：当权益人在非常住地期间因遭受意外伤害事故或突发急性病需要住院治疗时，本机构在服务额度范围内为权益人住院期间的医疗费用提供担保或垫付。
遗体/骨灰送返：权益人在非常住地身故的，根据其亲属的要求，本机构或授权代表根据事发当地实际情况并在不违反当地法律的情况下安排遗体保存或火化，且将权益人之遗体或骨灰送返其亲属指定的地点或权益人的合法有效证件所载的住所地。遗体/骨灰送返服务所需费用包括尸体防腐、保存、火化、运输及骨灰盒等材料和服务费用，本机构承担的此项费用总额最高以合同上载明的相应的服务限额为限。

当地安葬/丧葬费：权益人在非常住地身故的，根据其亲属的要求并在不违反当地法律的情况下，本机构或授权代表安排在事发当地安葬权益人。本机构承担安葬费用，最高费用总额以合同上载明的相应的服务限额为限。

亲属慰问探访：经本机构授权的医生与主治医生共同认定权益人在事故发生地的预计住院时间超过七（7）日(不包括7日)，根据权益人的要求，经本机构许可，该权益人的一名成年直系亲属可以前往权益人住院地点探视，本机构负责承担该亲属一套往返普通航班经济舱机票、船票、火车票、汽车票或其他更经济的交通方式的费用以及实际支出的合理住宿费，最高以合同上载明的相应的服务限额为限。

亲属处理后事：权益人于三十（30）天内在非常住地身故的，根据其亲属的要求，经本机构许可，权益人的一名成年直系亲属可以前往权益人身故地，本机构承担该亲属一套往返权益人身故地与亲属所在地的普通航班经济舱机票、船票、火车票或汽车票的费用以及实际支出的合理住宿费，最高费用总额以合同上载明的相应的服务限额为限。

电话医疗咨询：当权益人在非常住地期间，如身体不适或遇到紧急医疗状况，可拨打救援服务电话得到本机构医生的医疗咨询服务。

医疗机构介绍和建议：根据权益人要求及其身体状况、病情等，本机构向权益人介绍并推荐当地尽可能符合治疗要求的、或与本机构有合作关系的医疗机构，包括医生、医院、诊所、牙医等，内容包括名称、地址、电话、专长、工作时间等。

协助、安排就医住院：根据权益人身体状况、病情等，本机构协助权益人在当地尽可能符合治疗要求的、或与本机构有合作关系的医疗机构（医生、医院、诊所、牙医等）就医；如病情严重，本机构协助安排该权益人住院治疗。
        <div>请选择充值方式：
          <el-radio v-model="rechargeType1" label="1">微信充值</el-radio>
          <el-radio v-model="rechargeType1" label="2">对公充值</el-radio>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="recharge_type();dialogVisible0 = false">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="余额不足提醒设置" :visible.sync="balanceSettingsshow">
         <div>余额不足<el-input style="width:100px;margin:0px 10px" v-model="remindAmount"></el-input>元短信提醒</div>
         <div style="margin-top:15px">提醒电话<el-input style="width:200px;margin:0px 10px" v-model="remindMobile"></el-input></div>
         <div style="margin-top:15px">
          是否发送短信提醒
              <el-switch
              style="margin-left:30px"
              v-model="isRemind"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
         </div>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="balanceSettingsshow = false">取 消</el-button>
          <el-button type="primary" @click="balanceSettingsclick()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
	import axios from 'axios'
import { prestoreaccount,prestorerecords,prestoreupdateBalance,prestoretopay,prestoreto_card_pay,prestoredetail,prestoreset_recharge_type,rescue_saleprestoreaccount } from '@/axios/api.js'
import vueQr from "vue-qr";
import common from '@/assets/common.js'
export default {
  data() {
    return {
      isRemind:true,
      remindMobile:'',
      remindAmount:'',
      balanceSettingsshow:false,
      dialogVisible0:false,
      name:'',
      status:1,
      total:0,
      prestoreupdateBalanceshow:false,
      timer:null,
      timer1:null,
      rechargeType:'',
      rechargeType1:'1',
      bankAccount:'',
      amount:'1000',
      extraCssText:'',
      input:'',
      config: {
        imagePath: require('../../assets/img/logo2.png')//中间logo的地址
      },
      payImg:'../../assets/img/djx.png',
      actfsshow: 2,
      actshow: 1,
      radio: "1",
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      totalPayAmount:0,
      totalRechargeAmount:0,
      balance:0,
      tableData: [],
      currentPage4: 0,
      indexPage:0,
      eachPage:10,
    };
  },
  	components:{
			vueQr
		},
  methods: {
    balanceSettingsclick() {
      var isReminda = '1'
      if(this.isRemind == true) {
        isReminda = '1'
      }else {
        isReminda = '-1'
      }
      console.log(isReminda)
      if(this.remindAmount < 500) {
        console.log(this.switchmodel)
        this.$message.error('金额不能低于500')
        return
      }
      var obj = {
        remindMobile:this.remindMobile,
        remindAmount:this.remindAmount * 100,
        isRemind:isReminda
      }
      rescue_saleprestoreaccount(obj).then((res)=>{
    
        if(res.data.code == 0) {
          this.balanceSettingsshow = false
              this.$message({
              message: '设置成功',
              type: 'success'
            });
          }
      })
    },
    balanceSettings() {
      this.balanceSettingsshow = true
    },
      recharge_type() {
        var obj = {
          rechargeType:this.rechargeType1
        }
        prestoreset_recharge_type(obj).then((res)=>{
          if(res.data.code == 0) {
              this.$message({
              message: '设置成功',
              type: 'success'
            });
          }
          console.log(res)
        })
      },
    	handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.prestorerecords(this.indexPage,this.eachPage)
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val - 1) * this.eachPage;
				this.prestorerecords(this.indexPage,this.eachPage)
			}	,
    setstatus(str){
      if(str == 1) {
          return '进行中'
      }else if(str == 2) {
          return '已完成'
      }else if(str == 3) {
          return '失败'
      }
      
    },
    prestoretopay() {
      
    },
    setTime(str) {
      	return common.time(str)
      },
    prestoreupdateBalance(type,amount) {
        prestoreupdateBalance({type:type,amount:amount*100}).then((res)=>{
          
          this.$message({
          message: '提交成功，审核中',
          type: 'success'
        });
      
        this.prestoreupdateBalanceshow = true,
              this.getData();
        })
    },
    getData() {
      // type 类型：1 微信充值 2 微信提现  3 对公充值 4 对公提现
      // amount 金额
    //   prestoreaccount().then((res)=>{
    //   this.totalPayAmount = res.data.obj.totalPayAmount,
    //   this.totalRechargeAmount = res.data.obj.totalRechargeAmount,
    //   this.balance = res.data.obj.balance
    //   this.extraCssText  = res.data.obj.extraCssText 
    //   this.rechargeType = res.data.obj.rechargeType
    //   this.status = res.data.obj.status
    //   if(this.rechargeType == 0) {
    //       this.dialogVisible0 = true
    //     }else {
    //       this.dialogVisible0 = false
    //     }
    //     console.log(res)
    //     if(this.balance != 0) {
    //       if(this.rechargeType == 1) {
    //         this.actfsshow = 2
    //       }else {
    //         this.actfsshow = 1
    //       }
    //     }
          
    // console.log(res.data.obj.rechargeType,this.actfsshow)
    //   })
    let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
    	var form = new FormData() // FormData 对象
      	var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
      	form.append('token', token) // 文件对象
    axios.post(API_BASE + 'rescue_sale/prestore/account', form, config)
					.then(res => {
             console.log(res)
						if (res.data.code == 0) {
							this.totalPayAmount = res.data.obj.totalPayAmount,
      this.totalRechargeAmount = res.data.obj.totalRechargeAmount,
      this.balance = res.data.obj.balance
      this.extraCssText  = res.data.obj.extraCssText 
      this.rechargeType = res.data.obj.rechargeType
      this.status = res.data.obj.status
    
      if(this.balanceSettingsshow == false) {
        this.remindMobile = res.data.obj.remindMobile
        this.remindAmount = res.data.obj.remindAmount / 100
        if(res.data.obj.isRemind == '1') {
          this.isRemind = true
        }else {
          this.isRemind = false
        }
        
      }
      if(this.rechargeType == 0) {
          this.dialogVisible0 = true
        }else {
          this.dialogVisible0 = false
        }
        console.log(res)
        if(this.balance != 0) {
          if(this.rechargeType == 1) {
            this.actfsshow = 2
          }else {
            this.actfsshow = 1
          }
        }
             
						}else if(res.data.code == 101000){
              clearInterval(this.timer1)
							this.$message.error('token失效，请重新登录！')
							this.$router.push({
								path:'/login'
							})
						}
					})
					.catch(err => {
						console.log(err)
					})
    this.prestorerecords(this.indexPage,this.eachPage)
  
    },
    prestorerecords() {
        prestorerecords({start:this.indexPage,count:this.eachPage}).then((res)=>{
        for(var i = 0 ;i <res.data.obj.length; i++) {
          if(res.data.obj[i].recordType == 1) {
            res.data.obj[i].recordType = '微信充值'
          }else if(res.data.obj[i].recordType == 2) {
             res.data.obj[i].recordType = '微信提现'
          }else if(res.data.obj[i].recordType == 3) {
             res.data.obj[i].recordType = '对公充值'
          }else if(res.data.obj[i].recordType == 4) {
             res.data.obj[i].recordType = '对公提现'
          }
        }
        this.tableData = res.data.obj
        this.total = res.data.total
        console.log(res)
      })
    },
    act(ind) {
      this.actshow = ind;
       if(this.actshow == 1) {
        this.amount = 1000
      }else if(this.actshow == 2) {
        this.amount = 5000
      }else if(this.actshow == 3){
        this.amount = 10000
      }else {
        this.amount = 0;
      }
    },
    Rechargemode(ind) {
      if(ind == 1) {
           this.actfsshow = 2
      }else {
         this.actfsshow = 1
      }
     
    },
    tk() {
       var type = ''
       if(this.actfsshow == 2) {
        //  微信
        type = 1
      }else {
         type = 2
      }
      this.prestoreupdateBalance(type,this.balance)
    },
    tx() {
      console.log(this.tableData)
       this.dialogVisible = true;
      for(var i = 0; i<this.tableData.length;i++) {
        if(this.tableData[i].recordType == "对公充值") {
          this.name = this.tableData[i].remittanceAccount
          
          return
        }
      }
      
     
    },
    cz() {
      this.dialogVisible1 = true;
     
     
    },
    fu() {
     
      this.dialogVisible2 = true;
      if(this.amount == 0) {
        this.$message.error('金额不能为空！')
        return
      }
       var obj = {
         payType:1,
         amount:this.amount * 100
       }
       console.log(obj)
       prestoretopay(obj).then((res)=>{
             if(res.data.code == 105051) {
               this.dialogVisible2 = false
               this.$message.warning(res.data.msg);
                if(this.rechargeType == 1) {
                    this.actfsshow = 2
                  }else {
                    this.actfsshow = 1
                  }
             }else {
               this.payImg=res.data.obj.qrcodeurl;
             }
             console.log(res.data.code)
             console.log(res,'352')
            this.timer = setInterval(() => {
										 prestoredetail({billId:res.data.obj.bill.id}).then((res)=>{
                       if(res.data.obj.status == 2) {
                         this.$message({
                          message: '付款成功！',
                          type: 'success'
                        });
                         this.dialogVisible2 = false;
                          this.getData();
                         clearInterval(this.timer)
                       }
                        console.log(res)
                      })
									},1000)
            
         })
         
    //     var type = ''
    //    if(this.actfsshow == 2) {
    //     //  微信
    //     type = 1 
    //   }else {
    //      type = 3
    //   }
    // this.prestoreupdateBalance(type,this.amount)
      
    },
    fu1() {
      if(this.bankAccount == '') {
        this.$message.error('汇款账户名不能为空！')
        return
      }
      if(this.amount == 0) {
        this.$message.error('金额不能为空！')
        return
      }
      var obj = {
         amount:this.amount * 100,  //充值金额，整形，单位为分
         bankAccount:this.bankAccount //汇款账户名，字符串

      }
    prestoreto_card_pay(obj).then((res)=>{
      console.log()
      if(res.data.code == 0) {
         this.$message({
          message: '提交成功，审核中',
          type: 'success'
        });
        this.getData()
      }else if(res.data.code == 105051) {
        this.$message.warning(res.data.msg);
         if(this.rechargeType == 1) {
            this.actfsshow = 2
          }else {
            this.actfsshow = 1
          }
      }else {
        this.$message.warning(res.data.msg);
      }
     
    })
       
    },
  },
    mounted() {
      this.getData();
      console.log(this.rechargeType)
      
       this.timer1 =  setInterval(() => {
          this.getData();
      },5000)
                  
      
    },
};
</script>
<style  scoped="scoped">
.Recharge {
  height: 200px;
  padding: 10px 15px;
  border: 1px solid #cccc;
  margin-top: 10px;
}
.Recharge .left {
  display: inline-block;
  width: 49%;
  float: left;
}
.je {
  text-align: center;
  width: 32%;
  margin-top: 33px;
  display: inline-block;
}
.jeclass {
  width: 20%;
  height: 53px;
  line-height: 50px;
  border: 2px solid #cccc;
  border-radius: 10px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  margin-right: 5%;
}
.act {
  border: 2px solid #409eff;
}
.act1 {
  color: #409eff;
}
.fukuan {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
}
.el-dialog__body {
  width: 200px;
  height: 200px;
}
</style>
<style>
.fukuan1 img{
  width: 200px;
  height: 200px;
  margin-top:20px
}
</style>



// WEBPACK FOOTER //
// src/views/financial/preStorage.vue